import styled from "@emotion/styled";
import TextField from "@mui/material/TextField";

export const Input = styled(TextField)`
	background: transparent;
	color: #a3a3a3;
	border-radius: var(--input-border-radius, 4px);
	text-align: left;
	overflow: hidden;
	.MuiFilledInput-root {
		background: transparent;
	}

	.MuiInputLabel-root,
	.MuiInputLabel-root.Mui-focused {
		color: var(--input-color, #a3a3a3);
	}

	.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
		border-color: var(--secondaryColor);
	}

	.MuiFilledInput-root::before,
	.MuiFilledInput-root::after {
		border-radius: 3px;
	}

	.MuiFilledInput-root::after {
		border-color: #a3a3a3;
	}

	// Underline
	.MuiFilledInput-underline {
		background: var(--input-background-color, #2c2c2e);
		border-radius: 2px;
		color: #ffffff;
	}

	.MuiFilledInput-underline.Mui-focused:after {
		border-color: var(--secondaryColor);
	}
`;

Input.defaultProps = {
	variant: "outlined",
	fullWidth: true,
};
